"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ButtonsModule = _interopRequireDefault(require("./Buttons.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Buttons = /*#__PURE__*/_createClass(function Buttons() {
  _classCallCheck(this, Buttons);
});

exports["default"] = Buttons;

_defineProperty(Buttons, "Primary", function (props) {
  return /*#__PURE__*/_react["default"].createElement("button", _extends({
    //default props
    id: _ButtonsModule["default"].primaryButton,
    className: (0, _classnames["default"])(_defineProperty({
      "btn": true,
      "btn-block": true
    }, _ButtonsModule["default"].primaryDisabled, props.disabled)) //can add or override using

  }, props), props.children);
});

_defineProperty(Buttons, "Secondary", function (props) {
  return /*#__PURE__*/_react["default"].createElement("button", _extends({
    //default props
    id: _ButtonsModule["default"].secondaryButton,
    className: (0, _classnames["default"])(_defineProperty({
      "btn": true,
      "btn-block": true
    }, _ButtonsModule["default"].secondaryDisabled, props.disabled)) //can add or override using

  }, props), props.children);
});

_defineProperty(Buttons, "Text", function (props) {
  return /*#__PURE__*/_react["default"].createElement("button", _extends({
    //default props
    id: _ButtonsModule["default"].textButton,
    className: (0, _classnames["default"])(_defineProperty({
      "btn": true,
      "btn-block": true
    }, _ButtonsModule["default"].textDisabled, props.disabled)) //can add or override using

  }, props), props.children);
});

_defineProperty(Buttons, "Link", function (props) {
  return /*#__PURE__*/_react["default"].createElement("button", _extends({
    //default props
    id: _ButtonsModule["default"].linkButton,
    className: (0, _classnames["default"])(_defineProperty({
      "btn": true,
      "btn-block": true
    }, _ButtonsModule["default"].linkDisabled, props.disabled)) //can add or override using

  }, props), props.children);
});